'use strict';

import { spotify as spotifyOembed } from '../utils/oembed';

export default function () {
    const SELECTOR = '.js-spotify-thumbnail';

    for (const element of document.querySelectorAll(SELECTOR)) {
        spotifyOembed(element.dataset.spotifyUrl).then(response => {
            if (response.thumbnail_url) {
                element.src = response.thumbnail_url;
            }
        });
    }
}
